module.exports = "/img/service-1.e713b1d8.png";